import { render, staticRenderFns } from "./BusinessPlanReportConfirmation.vue?vue&type=template&id=55494303"
import script from "./BusinessPlanReportConfirmation.vue?vue&type=script&lang=ts"
export * from "./BusinessPlanReportConfirmation.vue?vue&type=script&lang=ts"
import style0 from "./BusinessPlanReportConfirmation.vue?vue&type=style&index=0&id=55494303&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports